import * as React from "react";

import { DirectionalHint } from "@fluentui/react/lib/ContextualMenu";
import { ITheme } from "@fluentui/react/lib/Styling";
import { Tooltip } from "@fluentui/react/lib/Tooltip";

import { AppThemeConsumer } from "@1js/acui-theme";
import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";

import { AppTooltipProps } from "./AppTooltip.Props";
import { getStyles } from "./AppTooltip.styles";

export class AppTooltip extends React.PureComponent<AppTooltipProps, {}> {
  public render() {
    const { content } = this.props;
    const resolvedContent = typeof content === "function" ? content() : content;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <Tooltip
            calloutProps={{
              styles: getStyles(
                theme,
                this.props.hidden,
                this.props.delayTooltip
              ),
              beakWidth: 10,
              bounds: getBoundingWindowWithPaddingFabric,
              gapSpace: this.props.topMargin,
            }}
            directionalHint={
              this.props.directionalHint
                ? this.props.directionalHint
                : DirectionalHint.bottomCenter
            }
            directionalHintForRTL={this.props.directionalHintForRTL}
            content={resolvedContent}
            targetElement={this.props.targetElement}
            onMouseEnter={this.props.mouseEnterCallback}
            onMouseLeave={this.props.mouseLeaveCallback}
            id={this.props.id}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
